import {fun_Download, fun_PostAction} from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        sectionId: null, // 标段编号
        tbUserId: null, // 用户编号
        fileType: null, // 文件类型
      },
      // 查询表单基础数据
      formSearchList: [
      
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "文件",
          prop: "tbMlmc",
        },
        {
          label: "操作",
          slotName: "op",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      // pdf路径
      pdfUrl: null,
      // 默认关闭弹窗
      pdfDialogVisible: false,
    }
  },
  // 接收父组件传递的数据
  props: {

  },
  // 模板编译完成
  mounted() { 

  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/evaluationPublicity/applyCatalogPublictyList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看
     * @author 滕威
     */
    fun_Look(e) {
      // 文件id
      var fileId = e.id;
      // 如果是资格预审公示资料
      if(e.FileType == '3'){
        // 重新拼接
        fileId = e.id + e.tbUserId + e.sectionId;
      }
      // 发起请求
     fun_PostAction("/evaluationPublicity/export", {
        filePath: e.filePath,  // 文件路径
        type: this.form.fileType, // 文件类型
        fileName: e.tbMlmc, // 文件名
        fileId: fileId, // 文件编号
        tenderReference: e.sectionId, // 招标编号
        corpName: e.corpName, // 企业名称
        pageNumber: e.ym, // 页码
        peopleId: e.tbUserId, // 用户编号
      }).then(res => {
        // 结构res.data
        const {
          result,
          data,
          msg
        } = res.data;
        // 请求成功
        if (result) {
          // 打开PDF弹框
          this.fun_OpenPdf(data);
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 调用PDF
     */
    fun_OpenPdf(e){
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        // 存储this
        const data = new Blob([res.data], { type: "application/pdf" });
        // 预览PDF
        this.pdfUrl =
            URL.createObjectURL(data);
      });
      // 打开弹窗
      this.pdfDialogVisible = true;
    },
    /**
    * 弹窗关闭的事件
    * @author shuhua
    */
    fun_HandleClose() {
      // pdf路径
      this.pdfUrl = null;
    }
  }
}